import React, { Component } from 'react'
import { connect } from 'react-redux';
import {Link} from 'react-router-dom'
import swal from 'sweetalert'
import * as actionsCreators from  '../../store/actions/index';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import InputBase from '@material-ui/core/InputBase';
import IconButton from '@material-ui/core/IconButton';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import moment from 'moment'
import MoreVertIcon from '@material-ui/icons/MoreVert';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import VisibilityOffOutlinedIcon from '@material-ui/icons/VisibilityOffOutlined';
import Popper from '@material-ui/core/Popper';
import MenuList from '@material-ui/core/MenuList';
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import ReactPaginate from 'react-paginate';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos'
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import TreatmentFacilityForm from './TreatmentFacilityForm';
// import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
// import MenuItem from '@material-ui/core/MenuItem';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import InputAdornment from '@material-ui/core/InputAdornment';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import LocationOnOutlinedIcon from '@material-ui/icons/LocationOnOutlined';
import CheckBoxOutlineBlankOutlinedIcon from '@material-ui/icons/CheckBoxOutlineBlankOutlined';
import GoogleMapReact from 'google-map-react';
import Marker from './Marker';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import { TimePicker } from '@material-ui/pickers'
// import moment from 'moment';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Grid from '@material-ui/core/Grid';
import DialogTitle from '@material-ui/core/DialogTitle';
import TablePagination from '@material-ui/core/TablePagination';
import { withTranslation } from 'react-i18next';
const options = [
    {
        id: "1",
        name: "FSTP",
    }, {
        id: "2",
        name: "STP",
    }, {
        id: "3",
        name: "Pumping/Decanting station",
    }
];
class TreatmentFacility extends Component {
    
    constructor(props) {
        super(props);
    this.handleMapClick = this.handleMapClick.bind(this);
      this.state = {
            anchorEl   : null,
            open       : false,
            id         : '',
            page:0,
            currentSortId:'asc',
            limit:10,
            sortObj : {
                key: '',
                value: ''
            },
            controls: {
                search: {
                    value: '',
                }
            },
            openDialog:false,
            tfNameEdit:'',
            usernameEdit:'',
            emailEdit:'',
            latitudeEdit:'',
            longitudeEdit:'',
            capacityEdit:'',
            locationNameEdit:'',
            wardEdit:'',
            amountEdit:'',                                
            operationalHoursFromEdit:'',
            operationalHoursToEdit:'',
            UserIdEdit:'',
            isCheckboxOnEdit:'',
            typeOfDisposalEdit:'',
            tippingFeeEdit:'',
            zoneEdit:'',
    
            tfName: "",
                username:  '',
                email: '',
                location: {
                    latitude: "",
                    longitude: ""
                },
                latitude: '',
                longitude:  '',
                capacity:  '',
                locationName:  '',
                ward:  '',
                amount: '',
                operationalHoursFrom:  moment(Date.now()).format('MM-DD-YYYY 09:00'),
                operationalHoursTo:  moment(Date.now()).format('MM-DD-YYYY 18:00'),
                receiptNumberPrefix: "",
                UserId: "",
                tfNameErr: "",
                usernameErr: "",
                emailErr: "",
                capacityErr: "",
                operationalHoursFromError: "",
                operationalHoursToError: "",
                amountErr: "",
                receiptNumberPrefixErr: "",
                longitudeErr: "",
                latitudeErr: "",
                isCheckboxOn: false,
                typeOfDisposal: '',
                facilityEmail: "",
                typeOfDisposalError: "",
                locationError: "",
                nameError: "",
                facilityIdError: "",
                locationNameErr: "",
                wardErr: "",
                feeError: "",
                position: 'inherit',
                left: '50%',
                top: '50%',
                zone:'',
                zoneErr:'',
             openEditDialog:false,
             tfID:'',
             password:"",
             passwordErr:"",
             isPasswordShown:false,
             WardEdit:'' // for prefiled edit data 
        }
    }
   
    componentDidMount() {
        let payload = {
            token  : this.props.token,
            page:this.state.page,
            limit:this.state.limit,
            sortName:this.state.sortObj.key,
            sortValue :this.state.sortObj.value,
            // searchQuery: this.state.controls.search.value
        }
        this.props.onFetchTreatmentHeaders(payload);
        this.props.onFetchTreatmentListing(payload)
    }
    handleClickMoreVertIcon=(event,id, tfNameEdit, usernameEdit,
        emailEdit,latitudeEdit, longitudeEdit, capacityEdit, locationNameEdit, wardEdit, amountEdit,
        operationalHoursFromEdit, operationalHoursToEdit, UserIdEdit, isCheckboxOnEdit, typeOfDisposalEdit, tippingFeeEdit, zoneEdit, WardEdit)=>{
        this.setState({open:!this.state.open,anchorEl:event.currentTarget,id:id, tfNameEdit, usernameEdit,
            emailEdit,latitudeEdit, longitudeEdit, capacityEdit, locationNameEdit, wardEdit, amountEdit,
            operationalHoursFromEdit, operationalHoursToEdit, UserIdEdit, isCheckboxOnEdit, typeOfDisposalEdit, tippingFeeEdit, zoneEdit, WardEdit})
      }
    handleClickAwayEdit = () => {
    this.setState({open:false});
    };
 
    handleDelete = (id, t) => {
        const payload = {
            id      : id,
        }
        const payload1={
            token: this.props.token,
            page:  this.state.page,
            limit: this.state.limit,
            sortName:this.state.sortObj.key,
            sortValue :this.state.sortObj.value,
        }
        this.props.onDeleteTreatmentFacility(payload,payload1, t)
    }
 
    handlePageClick = (e) => {
        const selectedPage = e.selected;
        this.setState({page: e.selected+1})
        let payload = {
            token: this.props.token,
            page:  selectedPage + 1,
            limit: this.state.limit,
            sortName:this.state.sortObj.key,
            sortValue :this.state.sortObj.value,
            // searchQuery: this.state.controls.search.value
        }
        this.props.onFetchTreatmentListing(payload)
    };
    // handleChangePage = (event, newPage) => {
    // //    console.log("Page", this.state.page);
    //     this.setState({page:newPage})
    //   };
    //   handleChangeRowsPerPage = (event) => {
    //     this.setState({limit:parseInt(event.target.value, 10),page:0});
        
    //   };
 
    handleSort = (e,sortBy) => {
        let sortObj
        if (this.state.sortObj.key === sortBy.accessor) {
            let value = (this.state.sortObj.value === 'desc') ? 'asc' : 'desc';
            sortObj = {
                key : sortBy.accessor,
                value: value
            }
        }
        else {
            sortObj = {
                key : sortBy.accessor,
                value: 'desc'
         }    
         }
 
        this.setState({ sortObj: sortObj ,currentSortId:sortBy.accessor});
        let payload = {
            token: this.props.token,
            sortName:sortObj.key,
         sortValue : sortObj.value,
         page: this.state.page,
         limit: this.state.limit,
        //  searchQuery: this.state.controls.search.value
        }
 
        this.props.onFetchTreatmentListing(payload);
 
      }
 
    //   handlePropertySearch = (e) => {
    //     e.preventDefault()
    //     let searchVal = this.state.controls.search.value
    //     if (!!searchVal && searchVal.length >= 2) {
    //         let payload = {
    //             token: this.props.token,
    //             searchQuery:searchVal,
    //             limit:10,
    //             page:this.state.page,
    //             // propertyTypeId: this.state.filterValue,
    //             sortName:this.state.sortObj.key,
    //             sortValue :this.state.sortObj.value,
             
    //         }
    //         this.props.onSearchTFName(payload)
    //     } else {
         
    //         swal("Enter atleast 2 characters")
    //     }
    // }
    // inputChangedHadler = (event, controlName) => {
    //     const updatedControls = {
    //         ...this.state.controls,
    //         [controlName]: {
    //             ...this.state.controls[controlName],
    //             value: event.target.value,
    //         }
    //     }
    //     this.setState({ controls: updatedControls });
    //     if( updatedControls.search.value === ''){
    //         let payload = {
    //             token: this.props.token,
    //             searchQuery:'',
    //             limit:this.state.limit,
    //             page:this.state.page,
    //             // propertyTypeId: this.state.filterValue,
    //             sortName:this.state.sortObj.key,
    //             sortValue :this.state.sortObj.value,
    //         }
    //         this.props.onSearchTFName(payload)
    //     }
    // }
 
    openPopupAddTF =()=>{
     this.setState({
        openDialog:true
     })
    }
 
    handleDialogClose = (value) => {
        this.setState({
            openDialog:value
        })
    }
    handleMap = (value) => {
        if (document.fullscreenElement) {
            this.setState({ position: 'fixed', top: 0, left: 0 })
        }
        else {
            this.setState({ position: 'inherit', top: '50%', left: '50%' })
        }
    }
    handleMapClick(x) {
        this.setState({ latitude: x.lat }, () => {
            this.checkValidity()
        })
        this.setState({ longitude: x.lng })
    }

    handleSubmit = (e) => {
        const {t, i18n} = this.props
        const props = this.props
        e.preventDefault()
        const err = this.checkValidity()
        if (!err) {
            const formdata = {
                Tfid:this.state.tfID,
                UserId: this.state.UserId,
                tfName: this.state.tfName,
                amount: this.state.amount ? Number(this.state.amount) : null,
                type: parseInt(this.state.typeOfDisposal),
                capacity: this.state.capacity ? Number(this.state.capacity) : null,
                operationalHoursFrom: moment(this.state.operationalHoursFrom).format('HH:mm'),
                operationalHoursTo: moment(this.state.operationalHoursTo).format('HH:mm'),
                receiptNumberPrefix: this.state.receiptNumberPrefix ? this.state.receiptNumberPrefix : null,
                username: this.state.username,
                email: this.state.email,
                location: {
                    latitude: parseFloat(this.state.latitude),
                    longitude: parseFloat(this.state.longitude)
                },
                locationName: this.state.locationName ? this.state.locationName : null,
                wardZone: this.state.ward ? this.state.ward : null,
                zone: this.state.zone ? this.state.zone : null,
                token: this.props.token,
                props: this.props,
                password:this.state.password
            }
           
            this.props.onEditTreatmentFacility(formdata, props, t)
            this.handleEditClose()
        }
    }


    handleChange = (e) => {
        // console.log("NAME", e.target.name)
        {this.setState({
            [e.target.name]: e.target.value
        }, () => {
            this.checkValidity()
        })
      }
    }
    toggleVisibilityTip = () => {   
        const { isCheckboxOn } = this.state
        this.setState({ isCheckboxOn: !isCheckboxOn }, () => {
            this.checkValidity()
        })
    }
    checkValidity = () => {
        const {t, i18n} = this.props
        let isError = false;
        if (!this.state.tfName) {
            isError = true
            this.setState({ tfNameErr: `${t("required")}` })
        }
        else if (this.state.tfName && this.state.tfName.length < 3 || this.state.tfName.length > 100) {
            isError = true
            this.setState({ tfNameErr: `${t("ulbnameErr")}` })
        }
        else if (this.state.tfName && this.state.tfName.length >= 3 && this.state.tfName.length <= 100) {
            // isError = false
            this.setState({ tfNameErr: "" })
        }
        if (!this.state.typeOfDisposal) {
            isError = true
            this.setState({ typeOfDisposalError: `${t("required")}` })
        }
        else if (this.state.typeOfDisposal) {
            this.setState({ typeOfDisposalError: "" })
        }
        if (!this.state.username) {
            isError = true
            this.setState({ usernameErr: `${t("required")}` })
        }
        else if (this.state.username && this.state.username.length < 3 || this.state.username.length > 20) {
            isError = true
            this.setState({ usernameErr: `${t("disposalNameErr")}` })
        }
        else if (this.state.username && this.state.username.length >= 3 && this.state.username.length <= 20) {
            // isError = false
            this.setState({ usernameErr: "" })
        }
        if (!this.state.email) {
            isError = true
            this.setState({ emailErr: `${t("required")}` })
        }
        else if (this.state.email) {
            var mailformat = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
            if (!this.state.email.match(mailformat)) {
                isError = true;
                this.setState({ emailErr: `${t("ulbEmailErr")}` })
            }
            else {
                // isError=false
                this.setState({ emailErr: "" })
            }
        }
        if (!this.state.capacity && !this.handleSubmit) {
            isError = true
            this.setState({ capacityErr: `${t("disposalCapacityErr1")}` })
        }
        else if (this.state.capacity) {
            if(!String(this.state.capacity).match(/^[+]?([0-9]+(?:[\.][0-9]*)?|\.[0-9]+)$/)){
                isError = true
                this.setState({ capacityErr: `${t("disposalCapacityErr2")}` })
            }
            else{
                this.setState({ capacityErr: "" })
            }
        }    
        if (this.state.isCheckboxOn) {
            if (!this.state.amount) {
                isError = true;
                this.setState({ amountErr: `${t("disposalAmountErr1")}` })
            }
            else if (this.state.amount) {
                if(!String(this.state.amount).match(/^[+]?([0-9]+(?:[\.][0-9]*)?|\.[0-9]+)$/)){
                    isError = true;
                    this.setState({ amountErr: `${t("disposalAmountPosErr")}`})
                }
                else{
                    this.setState({ amountErr: "" })
                }
            }
            if (this.state.receiptNumberPrefix) {
                this.setState({ receiptNumberPrefixErr: "" })
            }

        }
        if (!this.state.operationalHoursFrom) {
            isError = true
            this.setState({ operationalHoursFromError: `${t("required")}` })
        }
        else if (this.state.operationalHoursFrom) {
            this.setState({ operationalHoursFromError: "" })
        }
        if (!this.state.operationalHoursTo) {
            isError = true
            this.setState({ operationalHoursToError: `${t("required")}` })
        }
        else if (this.state.operationalHoursTo) {
            this.setState({ operationalHoursToError: "" })
        }
        if (this.state.operationalHoursFrom && this.state.operationalHoursTo) {
            if (moment(this.state.operationalHoursTo) <= moment(this.state.operationalHoursFrom)) {
                isError = true
                this.setState({ operationalHoursToError: "To hours cannot be lesser than/eqaul to from hours" })
            }
        }
        if (!this.state.latitude) {
            isError = true
            this.setState({ latitudeErr: `${t("required")}` })
        }
        else if (this.state.latitude) {
            this.setState({ latitudeErr: "" })
        }
        if (!this.state.longitude) {
            isError = true
            this.setState({ longitudeErr: `${t("required")}` })
        }
        else if (this.state.longitude) {
            this.setState({ longitudeErr: "" })
        }
        if (!this.state.locationName) {
            this.setState({ locationNameErr: "" })
        }
        else if (this.state.locationName) {
            if (this.state.locationName.length < 3 || this.state.locationName.length > 100) {
                isError = true
                this.setState({ locationNameErr: `${t("disposalLocalErr")}` })
            }
            else if (this.state.locationName && this.state.locationName.length >= 3 || this.state.locationName.length <= 100) {
                this.setState({ locationNameErr: "" })
            }
        }
        if (!this.state.ward) {
            this.setState({ wardErr: "" })
        }
        else if (this.state.ward) {
            if (this.state.ward.length > 100) {
                isError = true
                this.setState({ wardErr: `${t("disposalWardErr")}` })
            }
            else if (this.state.ward.length <= 100) {
                this.setState({ wardErr: "" })
            }
        }
        if(this.state.username && !this.state.password){
            isError = true
            this.setState({
                passwordErr:`${t("required")}`,
               
            })
        }
        else if(isError){
            isError = true
        }
        else{
            isError = false
            this.setState({
                passwordErr:''
            })  
        }
       
        
        if(this.state.username && this.state.password){
            if(!this.state.password.match(/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/)){
                isError = true
                this.setState({
                    passwordErr: `${t("ulbPassErr")}`
                })   
            }
            else if(isError){
                isError = true
            }
            else{
                isError = false
                this.setState({
                    passwordErr:''
                })   
            }
        }
        return isError
    }
    static defaultProps = {
        center: {
            lat: 17.123184,
            lng: 79.208824
        },
        zoom: 7,
        maps_key: "AIzaSyBV5XySVlxwJm_lAJ2ZoecKismiBv1ZJAo"
    };
    handleTimeFrom = (time) => {
        this.setState({ operationalHoursFrom: time }, () => {
            this.checkValidity()
        })
    }
    handleTimeTo = (time) => {
        this.setState({ operationalHoursTo: time }, () => {
            this.checkValidity()
        })
    }
    toggleVisibility=()=>{
        const{isPasswordShown}=this.state
        this.setState({isPasswordShown:!isPasswordShown})
      }
    handleEditDisposal=(tfID, tfName, username,
        email,latitude, longitude, capacity, locationName, ward, amount,
        operationalHoursFrom, operationalHoursTo, UserId, isCheckboxOn, typeOfDisposal, tippingFee, zone, wardE)=>{
        this.setState({
            openEditDialog:true,
            tfID:tfID,
            tfName:tfName,
            username:username,
            email:email,
            latitude:latitude,
            longitude:longitude,
            capacity:capacity,
            locationName:locationName,
            ward:ward,
            amount:amount,
            operationalHoursFrom:operationalHoursFrom,
            operationalHoursTo:operationalHoursTo,
            UserId:UserId,
            isCheckboxOn:isCheckboxOn,
            typeOfDisposal:typeOfDisposal,
            tippingFee:tippingFee,
            zone:zone,
            ward:wardE // for prefiled edit data 
         })
    }
    handleEditClose=()=>{
        this.setState({
            openEditDialog:false,
            tfNameErr:'',typeOfDisposalError:'',usernameErr:'',emailErr:'',
        capacityErr: "",
        operationalHoursFromError: "",
        operationalHoursToError: "",
        amountErr: "",
        receiptNumberPrefixErr: "",
        longitudeErr: "",
        latitudeErr: "",
        tfName: '',
        username:  '',
        email:  '',
        location: {
            latitude: "",
            longitude: ""
        },
        latitude:  '',
        longitude:'',
        capacity:  '',
        locationName: '',
        ward: '',
        amount:  '',
        operationalHoursFrom: moment(Date.now()).format('MM-DD-YYYY 09:00'),
        operationalHoursTo:  moment(Date.now()).format('MM-DD-YYYY 18:00'),
        zone:'',
        isCheckboxOn:  false,
        typeOfDisposal:  '',
        ward:'' // for prefiled edit data 
        })
    }

    // calling pagination funcation page wise
    handleChangePage = (event, newPage) => {
        // setPage(newPage);
        this.setState({page:newPage})
      };

    // calling pagination funcation row wise
    handleChangeRowsPerPage = (event) => {
        this.setState({limit:parseInt(event.target.value, 10),page:0});
        
      };
    render() {
        // console.log("TotalCount", this.props.totalCount)
        const {t, i18n} = this.props
        const headers =  this.props.headers.map(header => {  
            if(header.accessor === 'actionButton'){
                header.header = 'Action'
            }
            if(header.accessor === "Capacity"){
                header.header = 'Capacity (in KL per day)'
            }
          {
                return <TableCell key={header.header} className={"white-space"}>
                                <div style={{
                        display: 'flex',
                        alignItems: 'start',
                        whiteSpace: 'break-spaces',
                        height: '3em'
                    }}>
                {header.header === "Action"? "":
                    <div onClick={(e) =>  this.handleSort(e,header)}>
                        <div>{
                            this.state.currentSortId===header.accessor? this.state.sortObj.value ==='asc'?(<ArrowDropDownIcon fontSize="small"/>):(<ArrowDropUpIcon fontSize="small"/>) :(<ArrowDropDownIcon fontSize="small"/>)
                        }
                        </div>  
                    </div>}
                        {header.header}
                    </div>
                        </TableCell>
            }
        }
        ); 
        const facilities=!!this.props.treatmentListing&&this.props.treatmentListing.slice(this.state.page * this.state.limit, this.state.page * this.state.limit + this.state.limit).map((facility, j)=>{
            const id=facility["TFId"]
            const  tfNameEdit= facility["Name"]
            const usernameEdit=facility["UserName"]
            const emailEdit =facility["Email"]
            const  latitudeEdit=facility["Location"]["x"]
            const   longitudeEdit= facility["Location"]["y"]
            const  capacityEdit= facility["Capacity"]
            const locationNameEdit=facility["LocationName"]
            const wardEdit=facility["ward"]
            const   amountEdit=facility["Amount"]
            const    operationalHoursFromEdit = moment().format(`MM-DD-YYYY ${facility["OperationHoursFrom"]}`)
            const   operationalHoursToEdit= moment().format(`MM-DD-YYYY ${facility["OperationHoursTo"]}`)
            const   UserIdEdit=facility["UserId"]
            const  isCheckboxOnEdit=facility["Amount"] ? true : false
            const  typeOfDisposalEdit =facility["TreatmentFacilityTypeId"]
            const tippingFeeEdit =  facility["tippingFee"]
            const zoneEdit =  facility["Zone"] // for prefiled edit data 
            const WardEdit =  facility["Ward"] // for prefiled edit data 
            return <TableRow style={{whiteSpace: 'normal',
            wordWrap: 'break-word'}} key={j}>{
                this.props.headers.map((header, i)=>{
                       if(header.accessor=='actionButton'){
                        return  <TableCell  key={i}>
                                            <IconButton
                                            aria-label="more"
                                            aria-controls="long-menu"
                                            aria-haspopup="true"
                                            onClick={(e)=>this.handleClickMoreVertIcon(e,id, tfNameEdit, usernameEdit,
                                                emailEdit,latitudeEdit, longitudeEdit, capacityEdit, locationNameEdit, wardEdit, amountEdit,
                                                operationalHoursFromEdit, operationalHoursToEdit, UserIdEdit, isCheckboxOnEdit, typeOfDisposalEdit, tippingFeeEdit, zoneEdit, WardEdit)}
                                            >
                                            <MoreVertIcon fontSize='small'/>
                                            </IconButton>
                                                <Popper
                                                open={this.state.open} anchorEl={this.state.anchorEl}>
                                                 <ClickAwayListener onClickAway={this.handleClickAwayEdit}>
                                                <Paper  style={{boxShadow:"none", border:"1px solid #3dab35"}}>
                                                    <MenuList>
                                                     <MenuItem style = {{color: '#3dab35'}} onClick={()=>this.handleEditDisposal(this.state.id,this.state.tfNameEdit,this.state.usernameEdit,
                                                this.state.emailEdit,this.state.latitudeEdit,this.state.longitudeEdit, this.state.capacityEdit, this.state.locationNameEdit,
                                                this.state.wardEdit, this.state.amountEdit,this.state.operationalHoursFromEdit, this.state.operationalHoursToEdit, this.state.UserIdEdit,
                                                this.state.isCheckboxOnEdit, this.state.typeOfDisposalEdit, this.state.tippingFeeEdit, this.state.zoneEdit, this.state.WardEdit)}>{t("edit")}</MenuItem>
                                                       
                                                        {localStorage.getItem('phase2') == 'true' && <div>
                                                        <MenuItem style = {{color: '#3dab35'}} onClick={() => {
                                                             swal({ title : `${t("ulbDeleteErr1")}`,
                                                                    text : `${t("ulbDeleteErr2")}`,
                                                                    icon : "warning",
                                                                    buttons : {
                                                                    cancel : 'No',
                                                                    confirm: 'Yes'}
                                                            })
                                                            .then((willDelete) => {
                                                                if (willDelete) {
                                                                    this.handleDelete(this.state.id, t);
                                                                }
                                                            });
                                                        }}>{t("delete")}</MenuItem></div>}
                                                    </MenuList>
                                                </Paper>
                                                </ClickAwayListener>
                                            </Popper>
                                </TableCell>
                       }
                       else if(header.accessor=='Location'){
                           const location = facility[header.accessor]
                           if(location){
                            const lat = location["x"].toFixed(4)
                            const long = location["y"].toFixed(4)
                            return <TableCell style={{
                                whiteSpace: "normal",
                                wordWrap: "break-word"
                              }} key={facility[header.accessor]} >{lat},{long}</TableCell>
                           }
                           else{
                               return <TableCell style={{
                                whiteSpace: "normal",
                                wordWrap: "break-word"
                              }}key={location}>{location}</TableCell>
                           }
                       }
                       else if(header.accessor=='UpdatedAt'){
                        //    return <TableCell key={i} >{ (new Date(facility[header.accessor])).toLocaleString()}</TableCell>
                           return <TableCell style={{
                            whiteSpace: "normal",
                            wordWrap: "break-word"
                          }} key={i} >{ moment(facility[header.accessor]).format('DD-MMM-YYYY hh:mm a')}</TableCell>
                       }
                       else{
                           return  <TableCell style={{
                            whiteSpace: "normal",
                            wordWrap: "break-word"
                          }} key={i} className={"white-space"}>{facility[header.accessor]}</TableCell>
                       }
                })
            }
            </TableRow>
 
    })
        return (
            <div>
               
                 <div className="dashboard_right_content">
                        <img className="dashboard_right_content_top_icon" src="images/Rectangle.svg" />
                        <div className="dashboard_right_content_top">
                        <h5>{t("disposalFacl")}</h5>
                            <div className="dashboard_right_content_top_options">
                            {/* <div className="dashboard_right_content_top_search">
                                <Paper component="form">
                                    <IconButton aria-label="menu">
                                        <img src="images/search_icon.svg" />
                                    </IconButton>
                                    <InputBase onChange={(event) => this.inputChangedHadler(event, 'search')} placeholder="Name" />
                                    <Button onClick={this.handlePropertySearch} variant="contained" color="primary" type="submit">Search</Button>
                                </Paper>
                            </div> */}
                                <Button className="email_link" onClick={this.openPopupAddTF}>{t("addNewDisposal")} </Button>    
                            </div>
                        </div>
                    </div>
                    <div>
                    {(this.props.loadingTf === false ) ? <div id="cover-spin"></div>:''}
                    <div className="operator_listing" >
                        <TableContainer component={Paper} style={{paddingLeft:"15px",paddingRight:"15px"}}>
                             <Table stickyHeader aria-label="sticky table" style={{ tableLayout: 'fixed' }}>
                               
                                <TableHead >
                                    <TableRow >
                                        {headers}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                        {/* {facilities} */}
                                        {facilities.length === 0&& this.props.loadingTf == true ? <TableRow style={{textAlign:'center', fontWeight:'bold', fontSize: '13px', }}>
                                            No Records Found !!</TableRow>:facilities }
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </div>
                    {/* created new UI For page  */}
                    {
                        
                this.props.totalCount && this.props.totalCount != 0 &&
                    <TablePagination
                    rowsPerPageOptions={[10,50,100]}
                    colSpan={3}
                    count={this.props.totalCount}
                    component="div"
                    rowsPerPage={this.state.limit}
                    page={this.state.page}
                    SelectProps={{
                    inputProps: { 'aria-label': 'rows per page' },
                    native: true,
                    }}
                    labelRowsPerPage={t("rowsPerPage")}
                    containerClassName={"pagination"}
                    subContainerClassName={"pages pagination"}
                    onChangePage={this.handleChangePage}
                    onChangeRowsPerPage={this.handleChangeRowsPerPage}
                />
                }
            </div>
 
 
                    <TreatmentFacilityForm open={this.state.openDialog}  handleClose = {this.handleDialogClose} />









                <div>
                <Dialog open={this.state.openEditDialog}  aria-labelledby="form-dialog-title" maxWidth='md'>
                <DialogTitle className="text-center border-none " style={{color:'#3dab35'}}><span style={{fontSize:'18px'}}>{t("editDisposalFac")}</span></DialogTitle>
                <DialogContent>
                <div className="create_ulb_content_outer">
                                    <div className="create_ulb_content create_ulb_contentPop">
                <Grid container spacing={2}>
                    <Grid item xs={6}>
                        <FormControl>
                            <label className="required" htmlFor="tfName" align="left">{t("facilityName")}</label>
                            <TextField id="tfName"
                                variant="outlined"
                                value={this.state.tfName}
                                onChange={this.handleChange}
                                name="tfName"
                                placeholder={t("phfacilityName")} />
                            <div style={{ fontSize: 12, color: "red" }}>{this.state.tfNameErr}</div>
                        </FormControl>
                    </Grid>

                    <Grid item xs={6}>
                        <FormControl>
                            <label class="required" for="typeOfDisposal" align="left">{t("faclityType")}</label>
                            <Select value={this.state.typeOfDisposal} onChange={this.handleChange} name="typeOfDisposal">
                                {options.map((option) => (
                                    // <option value={option.id}>{option.name}</option>
                                    <MenuItem value={option.id}>{option.name}</MenuItem>
                                ))}
                            </Select>
                            <div style={{ fontSize: 12, color: "red" }}>{this.state.typeOfDisposalError}</div>
                        </FormControl>
                    </Grid>
                    <Grid item xs={6}>
                        <FormControl>
                            <label className="required" htmlFor="username" align="left">{t("facilityUser")} </label>
                            <OutlinedInput id="username"
                                variant="outlined"
                                value={this.state.username}
                                onChange={this.handleChange}
                                name="username"
                                placeholder={t("phfacilityUser")} />
                            <div style={{ fontSize: 12, color: "red" }}>{this.state.usernameErr}</div>
                        </FormControl>
                    </Grid>
                    <Grid item xs={6}>
                        <FormControl>
                            <label className="required" htmlFor="email" align="left">{t("facilityEmail")}</label>
                            <OutlinedInput id="email"
                                variant="outlined"
                                value={this.state.email}
                                onChange={this.handleChange}
                                name="email"
                                placeholder={t("phfacilityEmail")} />
                            <div style={{ fontSize: 12, color: "red" }}>{this.state.emailErr}</div>
                        </FormControl>
                    </Grid>
                    <Grid item xs={6}>
                     <form autocomplete="off">
                      <FormControl>
                      <label className={this.state.username ? "required" : ''} htmlFor = "password">{t("facilityPass")}</label>
                      
                      <OutlinedInput id = "password" 
                                      variant="outlined" 
                                      placeholder={t("phfacilityPass")}
                                      name="password" 
                                      value={this.state.password}
                                      onChange={this.handleChange}
                                      type={this.state.isPasswordShown ? "text" : "password"}
                                      endAdornment={this.state.isPasswordShown ?
                                        (<InputAdornment position="end"><VisibilityOffOutlinedIcon 
                                        onClick={()=>{this.toggleVisibility()}}
                                        /></InputAdornment>) :
                                        (<InputAdornment position="end">
                                            <IconButton
                                            aria-label="toggle password visibility"
                                            onClick={()=>{this.toggleVisibility()}}
                                            >
                                            <img src="images/eye.svg" />
                                        </IconButton> </InputAdornment> )    
                                        }
                                        errortext={this.state.passwordError}    
                                      />
                                     
                          <div style={{fontSize:12,color:"red", fontFamily:"'Open Sans', sans-serif", marginTop:"1%"}}>{this.state.passwordErr}</div>
                  </FormControl>
                  </form>
                    </Grid>
                    <Grid item xs={12}>
                        <div style={{ height: '30vh', width: '100%', paddingBottom: '15px', position: this.state.position, top: this.state.top, left: this.state.left }}>
                            <GoogleMapReact
                                bootstrapURLKeys={{ key: this.props.maps_key }}
                                defaultCenter={this.props.center}
                                defaultZoom={this.props.zoom}
                                onClick={this.handleMapClick}
                                onChange={this.handleMap}>
                                <Marker
                                    lat={this.state.latitude}
                                    lng={this.state.longitude}
                                    name="My Marker"
                                    color="blue" />
                            </GoogleMapReact>
                        </div>
                    </Grid>
                    <Grid item xs={6}>
                        <FormControl>
                            <label className="required" htmlFor="latitude" align="left">{t("latitude")}</label>
                            <OutlinedInput id="latitude"
                                variant="outlined"
                                disabled
                                value={evaluateLocation(this.state.latitude)}
                                onChange={this.handleChange}
                                name="latitude"
                                placeholder={t("phlatitude")}
                                endAdornment={<InputAdornment><LocationOnOutlinedIcon /></InputAdornment>} />
                            <div style={{ fontSize: 12, color: "red", }}>{this.state.latitudeErr}</div>
                        </FormControl>
                    </Grid>
                    <Grid item xs={6}>
                        <FormControl>
                            <label className="required" htmlFor="longitude" align="left">{t("longitude")}</label>
                            <OutlinedInput id="longitude"
                                variant="outlined"
                                disabled
                                value={evaluateLocation(this.state.longitude)}
                                onChange={this.handleChange}
                                name="longitude"
                                placeholder={t("phlongitude")}
                                endAdornment={<InputAdornment><LocationOnOutlinedIcon /></InputAdornment>} />
                            <div style={{ fontSize: 12, color: "red" }}>{this.state.longitudeErr}</div>
                        </FormControl>

                    </Grid>
                    <Grid item xs={6}>
                        <FormControl>
                            <label htmlFor="locationName" align="left">{t("location")}</label>
                            <OutlinedInput id="locationName"
                                variant="outlined"
                                value={this.state.locationName}
                                onChange={this.handleChange}
                                name="locationName"
                                placeholder={t("phlocation")} />
                            <div style={{ fontSize: 12, color: "red" }}>{this.state.locationNameErr}</div>

                        </FormControl>
                    </Grid>
               

                    <Grid item xs={6}>
                        <FormControl>
                            <label htmlFor="ward" align="left">{t("ward")}</label>
                            <OutlinedInput id="ward"
                                variant="outlined"
                                value={this.state.ward}
                                onChange={this.handleChange}
                                name="ward"
                                placeholder={t("ward")} />
                            <div style={{ fontSize: 12, color: "red" }}>{this.state.wardErr}</div>

                        </FormControl>

                    </Grid>
                    <Grid item xs={6}>
                        <FormControl>
                            <label htmlFor="ward" align="left">{t("zone")}</label>
                            <OutlinedInput id="ward"
                                variant="outlined"
                                value={this.state.zone}
                                onChange={this.handleChange}
                                name="zone"
                                placeholder={t("zone")} />
                            <div style={{ fontSize: 12, color: "red" }}>{this.state.zoneErr}</div>

                        </FormControl>

                    </Grid>
                    <Grid item xs={6}>

                    <FormControl>
                        <label htmlFor="capacity" align="left">{t("capacity")}</label>
                        <OutlinedInput id="capacity"
                            type="number"
                            min="1"
                            step="1"
                            variant="outlined"
                            value={this.state.capacity}
                            onChange={this.handleChange}
                            name="capacity"
                            placeholder={t("phcapacity")} />
                        <div style={{ fontSize: 12, color: "red" }}>{this.state.capacityErr}</div>
                    </FormControl>
                    </Grid>

                    <Grid item xs={6}>
                        <FormControl>
                            <label className="required" htmlFor="operationalHoursFrom" align="left">{t("operationalHoursFrom")} </label>
                            <MuiPickersUtilsProvider utils={MomentUtils}>
                                <TimePicker autoOk
                                    value={this.state.operationalHoursFrom}
                                    onChange={this.handleTimeFrom}
                                    InputProps={{ style: { fontSize: 'small', paddingLeft: '12px', paddingBottom: '7px', paddingTop: '7px', fontFamily: "'Open Sans', sans-serif !important}" } }} />
                                <div style={{ fontSize: 12, color: "red" }}>{this.state.operationalHoursFromError}</div>
                            </MuiPickersUtilsProvider>
                        </FormControl>

                    </Grid>
                    <Grid item xs={6}>
                        <FormControl>
                            <label className="required" htmlFor="operationalHoursTo" align="left">{t("operationalHoursTO")}</label>
                            <MuiPickersUtilsProvider utils={MomentUtils}>
                                <TimePicker autoOk
                                    value={this.state.operationalHoursTo}
                                    onChange={this.handleTimeTo}
                                    InputProps={{ style: { fontSize: 'small', paddingLeft: '12px', paddingBottom: '7px', paddingTop: '7px', fontFamily: "'Open Sans', sans-serif !important}" } }} />
                                <div style={{ fontSize: 12, color: "red" }}>{this.state.operationalHoursToError}</div>
                            </MuiPickersUtilsProvider>
                        </FormControl>
                    </Grid>
                
                    <Grid container spacing={1} item xs={6}>
                    
                        <Grid item xs={12}>
                        <FormControl>
                        <label htmlFor="amount" align="left" style={{ display: "flex", align: 'center', alignItems: "center" }}>{t("amount")}
                        {!this.state.isCheckboxOn ? <CheckBoxOutlineBlankOutlinedIcon onClick={() => { this.toggleVisibilityTip() }} /> : <CheckBoxIcon style={{ color: "#3dab35" }} onClick={() => { this.toggleVisibilityTip() }} />}</label>
                        </FormControl>
                            {this.state.isCheckboxOn ?
                            
                                <div>
                                    <FormControl style={{width:'100%', float: "left"}}>
                                        <label className="required" htmlFor="amount" align="left">{t("amount")}</label>
                                        <OutlinedInput id="amount"
                                            // type="number"
                                            variant="outlined"
                                            // min="0"
                                            // step="1" 
                                            value={this.state.amount}
                                            onChange={this.handleChange}
                                            name="amount"
                                            placeholder={t("phamount")} />
                                        <div style={{ fontSize: 12, color: "red" }}>{this.state.amountErr}</div>
                                    </FormControl>
                        &emsp;&emsp;&emsp;
                        </div> : null}
                        </Grid>
                    </Grid>
                            
                    <Grid item xs={12}>
                        <div className="create_ulb_buttons">
                         <Button className="login_submit" variant="outlined" color="primary" onClick={this.handleEditClose }>{t("cancel")}</Button>
                            <Button className="login_submit" variant="contained" color="primary" onClick={this.handleSubmit}>{t("saveChange")}</Button>
                        </div>
                    </Grid>

                </Grid>
                </div>
                </div>
        </DialogContent>
    </Dialog>

            </div>
            </div>
        )
    }
}


/**
 * Evaluates lat long for 4 digit precision
 * @param {*} loc - Lat Long for evaluation
 */
 function evaluateLocation(loc) {
    return loc.toString().length > 0 ? parseFloat(loc).toFixed(4) : "";
}

const mapStateToProps = state => {
    return {
        token: state.auth.token,
        headers:state.treatmentHeaders.headers,
        treatmentListing:state.treatmentListing.treatmentListing,
        totalCount:state.treatmentListing.totalCount,
        loadingTf: state.treatmentListing.loading
    }
}
 
const mapDispatchToProps = dispatch => {
    return {
        onFetchTreatmentHeaders: (payload) => dispatch(actionsCreators.fetchTreatmentHeaders(payload)),
        onFetchTreatmentListing: (payload) => dispatch(actionsCreators.fetchTreatmentListing(payload)),
        onDeleteTreatmentFacility : (payload,payload1, t) => dispatch(actionsCreators.deleteTreatmentFacility(payload, payload1, t)),
        onSearchTFName :(payload)=>dispatch(actionsCreators.searchTFName(payload)),
        onEditTreatmentFacility: (payload, props, t) => dispatch(actionsCreators.editTreatmentListing(payload, props, t)),
    }
}
 
export default  connect(mapStateToProps, mapDispatchToProps) (withTranslation() (TreatmentFacility));

